import urls from 'consts/urls';
import api from 'helpers/api';

export const getPublicTours = (data = {}) => {
  return api.patch(urls.PUBLIC_TOURS, data);
};
